module.exports = "<th>Наличие оборудования</th>\n<td>\n    <div class=\"filter__button-group\">\n        <term source=\"source.has_equipment\"\n              behavior=\"checkbox\"\n              text=\"С оборудованием\"\n        ></term>\n\n        <term source=\"source.has_equipment\"\n              behavior=\"checkbox\"\n              text=\"Без оборудования\"\n              opposite=\"true\"\n        ></term>\n    </div>\n</td>"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/commercial/has_equipment.html
// module id = 330
// module chunks = 0